export { default } from './Faq.js'
export { FaqItem } from './Faq.js'
